<section class="users-view">
    <!-- Media object starts -->
    <div class="row">
      <div class="col-12 col-sm-7">
        <div class="media d-flex align-items-center">
          <a href="javascript:;">
            <img
              *ngIf="!channel_data?.image"  
              src="assets/MeanderLIVE-icon.png"
              alt="user view avatar"
              class="users-avatar-shadow rounded"
              height="64"
              width="64"
            />
            <img
              *ngIf="channel_data?.image"
              [src]="imageUrl + channel_data?.image"
              alt="user view avatar"
              class="users-avatar-shadow rounded"
              height="64"
              width="64"
            />
          </a>
          <div class="media-body ml-3">
            <h4>
              <span class="users-view-name mr-1">{{
                channel_data?.name
              }}</span>
              <!-- <span class="text-muted font-medium-1">
                    <span>@</span>
                    <span class="users-view-username">dean3004</span>
                  </span> -->
            </h4>
            <!-- <span class="mr-1">ID :</span> -->
            <!-- <span class="users-view-id">{{
              channel_data?._id.substring(channel_data?._id.length - 6)
            }}</span> -->
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-5 d-flex justify-content-end align-items-center">
        <!-- <a
          href="javaScript:void(0);"
          class="btn btn-sm bg-light-secondary mr-2 px-3 py-1"
          ><i class="ft-mail"></i
        ></a>
        <a
          href="javaScript:void(0);"
          class="btn btn-sm bg-light-secondary mr-2 px-3 py-1"
          >Profile</a
        > -->
        <!-- <a
          class="btn btn-sm btn-primary px-3 py-1"
          [routerLink]="['/channel/edit',channel_data?._id]">Edit</a> -->
      </div>
    </div>
    <!-- Media object ends -->
  
    <div class="row">
      <div class="col-12">
        <!-- Card data starts -->
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-12 col-xl-4">
                  <h5 class="mb-2 text-bold-500">
                    <i class="ft-info mr-2"></i> Channel Info
                  </h5>
                  <table class="table table-borderless">
                    <tbody>
                      <tr>
                        <td>Name:</td>
                        <td>{{ channel_data?.name }}</td>
                      </tr>
  
                      <tr>
                        <td>Category:</td>
                        <td>
                          {{ channel_data?.category?.displayname }}
                        </td>
                      </tr>
                      <tr>
                        <td>Technology:</td>
                        <td>
                            {{ channel_data?.technology?.displayname }}
                        </td>
                      </tr>
                      <tr>
                        <td>Notes:</td>
                        <td>{{ channel_data?.notes}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end -->
      </div>
    </div>
  </section>
  